import "./style.css";
import { jsx as n } from "react/jsx-runtime";
import { c as p } from "../../__shared__/index.js";
const i = "_content_18wxu_1", h = "_hideEmptyParagraphs_18wxu_57", r = {
  content: i,
  hideEmptyParagraphs: h
};
function u({
  children: t = "",
  as: a = "div",
  className: s,
  style: e,
  showEmptyParagraphs: m,
  ...o
}) {
  return /* @__PURE__ */ n(
    a,
    {
      ...o,
      className: p(r.content, s, {
        [r.hideEmptyParagraphs]: !m
      }),
      style: e,
      dangerouslySetInnerHTML: { __html: (t == null ? void 0 : t.trim()) || "" }
    }
  );
}
export {
  u as default
};
//# sourceMappingURL=FormattedText.js.map
